<template>
  <div class="card">
    <header class="card-header has-background-primary-light">
      <div class="card-header-title is-block">
        <div class="is-flex is-align-items-center mb-4">
          <h2 class="title is-4 has-text-weight-bold has-text-dark">
            Carrito de pedido
          </h2>
        </div>
      </div>
    </header>

    <div class="card-content">
      <div class="content">
        <div class="block">

          <div>
            <b-field label="Lista de archivos">
              <b-table
                :data="getCar"
                :bordered="false"
                :striped="true"
                :narrowed="true"
                :hoverable="true"
                :loading="false"
                :mobile-cards="true"
                :sortable="false"
                class="is-fullwidth has-background-white"
              >

                <template v-slot:default="props">
                  <b-table-column v-if="props.row.type==='FILE'" label="Código">
                    {{ getUniqueNameFile(props.row) }}
                  </b-table-column>

                  <b-table-column v-if="props.row.type==='MEDIOS'" label="Código">
                    {{ props.row.code }}
                  </b-table-column>

                  <b-table-column v-if="props.row.box" label="Caja">
                    {{ props.row.box }}
                  </b-table-column>

                  <b-table-column v-if="props.row.box" label="Nombre">
                    {{ props.row.name }}
                  </b-table-column>

                  <b-table-column v-if="props.row.box" label="Descripción">
                    {{ props.row.description }}
                  </b-table-column>

                  <b-table-column v-if="props.row.type==='MEDIOS'" label="Observación">
                    {{ props.row.observation }}
                  </b-table-column>

                  <b-table-column>
                    <b-tooltip label="Eliminar" type="is-danger" position="is-left">
                      <button
                        class="button is-danger is-light is-small is-rounded"
                        @click="deleteItemFromCar(props.row)"
                        style="display: flex; align-items: center; justify-content: center;"
                      >
                        <b-icon icon="delete" size="is-small"></b-icon>
                      </button>
                    </b-tooltip>

                  </b-table-column>
                </template>

                <template v-slot:empty>
                  <div class="section">
                    <div class="content has-text-grey has-text-centered">
                      <p>
                        <b-icon
                          icon="emoticon-sad"
                          size="is-large">
                        </b-icon>
                      </p>
                      <p class="has-text-grey">El carrito está vacío</p>
                      <p class="has-text-grey is-size-7">Agregue elementos</p>
                    </div>
                  </div>
                </template>
              </b-table>
            </b-field>

            <br>

            <div class="columns is-multiline">
              <div class="column is-6">
                <b-field label="Responsable" expanded>
                  <p class="subtitle is-6">{{ responsable }}</p>
                </b-field>
              </div>

              <div class="column is-6">
                <b-field label="Comentario" expanded>
                  <b-input v-model="comment"></b-input>
                </b-field>
              </div>

              <div class="column is-12">
                <div class="columns is-multiline">

                  <div class="column is-6">
                    <b-field label="Fecha de entrega">
                      <b-datepicker
                        placeholder="Ingresa la fecha de entrega"
                        icon="calendar-today"
                        v-model="deliveryDate"
                        :readonly="false"
                        :min-date="minDate">
                      </b-datepicker>
                    </b-field>
                  </div>

                  <div class="column is-6">
                    <b-field label="Hora de entrega">
                      <b-timepicker
                        placeholder="Ingresa la hora de entrega"
                        icon="clock"
                        v-model="deliveryDate"
                        :readonly="false"
                        :min-time="minTime"
                        :max-time="maxTime"
                      ></b-timepicker>
                    </b-field>
                  </div>

                  <div class="column is-12">
                    <b-field label="Prioridad de entrega">
                      <b-field>
                        <div v-for="(priorityLvl, index) in priorityHoursArray" :key="index">
                          <b-radio-button v-model="priority"
                                          :native-value="priorityLvl.name"
                                          type="is-info">
                            <span>{{ priorityLvl.name.charAt(0).toUpperCase() + priorityLvl.name.slice(1) }}</span>
                          </b-radio-button>
                        </div>
                      </b-field>
                    </b-field>
                  </div>
                </div>
              </div>

              <div class="column is-12">
                <b-field label="Dirección de entrega" expanded>
                  <b-autocomplete
                    v-model="deliveryAddress"
                    placeholder="Ej. Calle Dean Valvidia 148"
                    :open-on-focus="true"
                    :data="addressList"
                    @select="option => deliveryAddress = option">
                  </b-autocomplete>
                  <!--<b-input v-model="deliveryAddress"></b-input>-->
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="modal-card-foot is-centered">
      <button @click="registerOrder" :disabled="!validateFormPedido" class="button is-success">Registrar pedido</button>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import Util from '../util'
import {calculateDeliveryDate} from "../util/deliveryDateCalculator";

export default {
  data() {
    const today = new Date()
    return {
      responsable: null,
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      minTime: new Date(),
      maxTime: null,
      deliveryDate: new Date(),
      comment: null,
      deliveryAddress: '',
      addressList: [],
      priority: 'normal',
      businessHours: null,
      priorityHoursArray: [],
      isAutoChange: false,
    }
  },
  computed: {
    ...mapGetters({'getCar': 'car/getCar'}),
    ...mapGetters({'getStorageMode': 'car/getStorageMode'}),
    ...mapGetters({'getClient': 'auth/getClient'}),

    validateFormPedido() {
      return !(this.getCar.length === 0 || this.deliveryDate == null || this.deliveryAddress == null || this.deliveryAddress === '');
    },

  },
  methods: {
    ...mapActions({'removeItemFromCar': 'car/removeItemFromCar', 'cleanCar': 'car/cleanCar'}),
    ...mapActions({'saveOrder': 'orders/saveOrder'}),
    ...mapMutations({
      'updateStatusBoxesToReq': 'boxes/updateStatusBoxesToReq',
      'updateStatusFilesToReq': 'files/updateStatusFilesToReq'
    }),

    deleteItemFromCar(file) {
      this.removeItemFromCar(this.findIndexFileInCar(file))
    },

    findIndexFileInCar(file) {
      return this.getCar.findIndex(obj => obj === file)
    },

    registerOrder() {
      const order = {
        idClient: Util.getAuth().idClient,
        idUser: Util.getAuth().idUser,
        nameUser: Util.getAuth().name,
        comment: this.comment,
        deliveryDate: this.deliveryDate,
        items: this.getCar,
        deliveryAddress: this.deliveryAddress,
        priority: this.priority,
        storageMode: this.getStorageMode
      };

      this.saveOrder({context: this, order}).then(() => {
        this.cleanCar();
        this.$emit('close');
        this.$toast.open('Pedido registrado correctamente!');

        // Emite evento global para que ConsultaPorCaja.vue recargue
        this.$eventHub.$emit('reloadBoxes');
      });
    },

    getUniqueNameFile(file) {
      if (file.code)
        return file.code
      if (file.description)
        return file.description
      if (file.name)
        return file.name
    },

    changePriority() {
      if (!this.getClient) return;

      const suggestedDate = calculateDeliveryDate(this.priority, this.getClient);
      this.isAutoChange = true;

      this.deliveryDate = suggestedDate;
      this.minDate = new Date(suggestedDate);
      this.minTime = new Date(suggestedDate);

      // límite superior según horario de atención
      if (this.businessHours && this.businessHours.hours) {
        const endHour = this.businessHours.hours.to;
        const max = new Date(suggestedDate);
        max.setHours(endHour, 0, 0, 0);
        this.maxTime = max;
      }
    }
  },

  watch: {
    'priority': 'changePriority',

    deliveryDate(newVal) {
      if (!newVal || !this.businessHours) return;

      const {from: startHour, to: endHour} = this.businessHours.hours;
      const adjusted = new Date(newVal);

      if (this.isAutoChange) {
        this.isAutoChange = false;
        return;
      }

      // Caso 1: antes del inicio de jornada
      if (adjusted.getHours() < startHour) {
        adjusted.setHours(startHour, 0, 0, 0);
      }

      // Caso 2: después del fin de jornada
      if (adjusted.getHours() > endHour || (adjusted.getHours() === endHour && adjusted.getMinutes() > 0)) {
        adjusted.setHours(endHour, 0, 0, 0);
      }

      if (adjusted.getTime() !== newVal.getTime()) {
        this.$nextTick(() => {
          this.deliveryDate = adjusted;
        });
      }
    }

  },

  created() {
    this.responsable = Util.getAuth().name
    this.addressList = Util.getClientAddress()
    this.businessHours = this.getClient.businessHours

    if (this.getClient.deliveryRules && this.getClient.deliveryRules.length > 0) {
      this.priorityHoursArray = this.getClient.deliveryRules.map(rule => ({
        name: rule.priority,
        type: rule.type,
        value: rule.hours,
        conditions: rule.conditions || []
      }))
    } else if (this.businessHours && this.businessHours.priorityHours) {
      this.priorityHoursArray = Object.keys(this.businessHours.priorityHours).map((key) => ({
        name: key,
        type: "WORKING_HOURS", // por compatibilidad
        value: this.businessHours.priorityHours[key],
        conditions: []
      }))
    }

    // Fecha inicial sugerida
    this.changePriority()
  },

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Carrito.vue